import { useEffect } from "react";

import { Nav, Footer } from "../components/Nav";
import cover from "../images/Cakery/Cakery Cover.png";

import sketchImg from "../images/Cakery/Cakery Sketch.png";
import moodImg from "../images/Cakery/Cakery Mood Board.png";
import wipImg from "../images/Cakery/Cakery WIP.png";
import logosImg from "../images/Cakery/Cakery Logo Poster.jpg";
import productImg from "../images/Cakery/Cakery product sketch.png";
import mockup1Img from "../images/Cakery/Cakery Mockup 1.png";
import mockup2Img from "../images/Cakery/Cakery Mockup 2.png";
import mockup3Img from "../images/Cakery/Cakery Mockup 3.png";
import posterImg from "../images/Cakery/Cakery Mockup Poster.png";
import {
  ProjectInfo,
  TextSection,
  MoreSection,
} from "../components/ProjectDetails";

export default function Cakery() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <>
      <Nav color="white" />
      <header id="project-cover" className="cakery">
        <h1 className="accent-text">Cakery</h1>
        <p>Logo and brand design project of a bakery inspired by bunnies.</p>
        <img id="cover" src={cover} alt="Cakery Cover" />
      </header>

      <main id="project-detail-main" className="cakery">
        <ProjectInfo
          role={["Graphic Designer"]}
          team={["Solo Project"]}
          toolkit={["Adobe Illustrator", "Adobe Photoshop"]}
          duration="1 Month (2023)"
        />
        <TextSection
          type="callout first-section last-section"
          header="project overview"
          title="The Goal"
        >
          <p>
            The goal of the project is to create a logo and brand identity
            around the concept of bunnies.
          </p>
          <p>
            The final design features an adorable logo that combines a cute
            bunny with a birthday cake. The elements in the logo are integrated
            into various packaging designs to bring playfulness and joy to every
            aspect of the bakery.
          </p>
        </TextSection>

        <TextSection
          type="normal-text first-section"
          header="Research"
          title="Understanding Their Characteristics"
        >
          <p>
            Before beginning the design process, I researched rabbits to better
            understand their characteristics and physical appearance. This
            research allowed me to incorporate them effectively and creatively
            into the logo and brand design.
          </p>
          <a
            href="https://drive.google.com/file/d/1mUAaHVeChY376gPpUIeCdoeRWKy1Y_32/view?usp=sharing"
            target="_blank"
            className="primary-button accent-btn"
            rel="noreferrer"
          >
            View Report
          </a>
        </TextSection>

        <TextSection
          type="normal-text"
          header="Exploration"
          title="Logo Sketches"
        >
          <p>
            Through sketching, I explored a range of logo styles and brand
            concepts. Ultimately, I chose to further develop Logo 13, as I loved
            how an upside-down bunny creatively resembles frosting drips on
            cakes.
          </p>
          <img src={sketchImg} alt="Cakery Logo Sketches" />
        </TextSection>

        <TextSection type="normal-text" header="Exploration" title="Mood Board">
          <p>
            After finalizing the rough logo, I began developing a brand around
            the idea of a local bakery. I envisioned myself as a bakery owner,
            crafting a brand that would be both joyful and welcoming for
            everyone in the community.
          </p>
          <img src={moodImg} alt="Cakery Mood Board" />
        </TextSection>
        <TextSection
          type="normal-text last-section"
          header="Designing"
          title="Logo Iterations"
        >
          <p>
            Below are two of the iterations created in Illustrator. From the
            left logo to the right, I added horizontal bars to represent layers
            of the cake.
          </p>
          <img src={wipImg} alt="Cakery Logo Iterations" />
        </TextSection>

        <TextSection
          type="callout first-section last-section"
          header="final design"
          title="Logo Design"
        >
          <p>
            In the final logo, I also swapped the original circle with a flame
            to better represent a birthday cake and to evoke a sense of
            celebration.
          </p>
          <img src={logosImg} alt="Cakery Final Logo Designs" />
        </TextSection>
        <TextSection
          type="normal-text first-section last-section"
          header="Designing"
          title="Product Sketching"
        >
          <p>
            After finalizing the logo, I tackled the package design by sketching
            a variety of potential packaging and merchandise for the brand.
          </p>
          <img src={productImg} alt="Cakery Product Sketches" />
        </TextSection>

        <TextSection
          type="callout first-section last-section"
          header="final design"
          title="Cakery Mockups"
        >
          <p>
            The final mockup showcases a variety of packaging that Cakery would
            use. Some designs feature the entire logo, while others incorporate
            elements of the logo, molding to the shape of each specific
            packaging type.
          </p>
          <img src={mockup1Img} alt="Cakery Final Mockup 1" />
          <img src={mockup2Img} alt="Cakery Final Mockup 2" />
          <img src={mockup3Img} alt="Cakery Final Mockup 3" />
        </TextSection>

        <TextSection
          type="normal-text first-section last-section"
          header="Final Design"
          title="All Mockups"
        >
          <img src={posterImg} alt="Cakery Mockup Poster" />
        </TextSection>
      </main>
      <MoreSection exclude={["cakery"]} />

      <Footer />
    </>
  );
}
